<template>
  <div class="content-box bg-none sc-page-wrap">
    <div class="top-cont">
      <div class="switch-group">
        <div class="col">
          <div class="tit">{{t('message.safetyObservation')}}</div>
          <v-switch v-model="bbsModel" inset hide-details @change="changeSwitch"/>
        </div>
        <div class="col ty01">
          <div class="tit">{{t('message.safetyLeadership')}}</div>
          <v-switch v-model="leadershipModel" inset hide-details @change="changeSwitch"/>
        </div>
        <div class="col ty02">
          <div class="tit">{{t('message.correctiveAction')}}</div>
          <v-switch v-model="timelineModel" inset hide-details @change="changeSwitch"/>
        </div>
      </div>
      <div>
        <div class="selected-group3">
          <v-select
            v-model="calenderModel"
            :items="CalenderItems"
            item-title="title"
            item-value="value"
          ></v-select>
        </div>
      </div>
    </div>
    <div class="content-inner-box">
      <div class="nodata-group" v-if="todoList.length == 0 && endList.length == 0">
        <div class="txt">{{t('message.noRegisteredData')}}</div>
      </div>
      <div class="list-group4 scrollbar">
        <div class="box" v-if="todoList.length > 0">
          <div class="txt-date">TODO</div>
          <div class="list-inner">
            <div class="header-group">
              <div class="col">{{t('message.title')}}</div>
              <div class="col">{{t('message.stage')}}</div>
              <div class="col">{{t('message.progress')}}</div>
              <div class="col">{{t('message.period')}}</div>
            </div>
            <ul>
              <li
              v-for="(item, i) in todoList"
              :key="'todo'+i"
              :class="getClass(item)">
                <v-btn  @click="onClickItem(item)">
                  <span class="t1">{{ item.title }}</span>
                  <span class="t2">{{ item.type != 't'?item.periodSeq+t('message.sessionNumber'):'' }}</span>
                  <span class="t3">{{ getStatus(item) }}</span>
                  <span class="t4">{{ item.type != 't'?dayjs(item.startDate).format('YYYY-MM-DD')+'~'+dayjs(item.endDate).format('YYYY-MM-DD'):item.formatDate}}</span>
                </v-btn>
              </li>
            </ul>
          </div>
        </div>
        <div class="btn-group">
          <c-btnLine01 :btnText="''" :btn-show="true" class="ty05" v-if="todoListOri.length > 10 && todoList.length <= 10" @click="onClickListToggle('1','open')"/>
          <c-btnLine01 :btnText="''" :btn-show="true" class="ty06" v-if="todoListOri.length > 10 && todoList.length > 10" @click="onClickListToggle('1','close')"/>
        </div>
        <div class="box" v-if="endList.length > 0">
          <div class="txt-date">{{t('message.incomplete')}}</div>
          <div class="list-inner">
            <div class="header-group">
              <div class="col">{{t('message.title')}}</div>
              <div class="col">{{t('message.stage')}}</div>
              <div class="col">{{t('message.progress')}}</div>
              <div class="col">{{t('message.period')}}</div>
            </div>
            <ul>
              <li
                v-for="(item, i) in endList"
                :key="'todo'+i"
                :class="getClass(item)">
                <v-btn  @click="onClickItem(item)">
                  <span class="t1">{{ item.title }}</span>
                  <span class="t2">{{ item.type != 't'?item.periodSeq+t('message.sessionNumber'):'' }}</span>
                  <span class="t3">{{ getStatus(item) }}</span>
                  <span class="t4">{{ item.type != 't'?dayjs(item.startDate).format('YYYY-MM-DD')+'~'+dayjs(item.endDate).format('YYYY-MM-DD'):dayjs(item.goalDate).format('YYYY-MM-DD')}}</span>
                </v-btn>
              </li>
            </ul>
          </div>
        </div>
        <div class="btn-group">
          <c-btnLine01 :btnText="''" :btn-show="true" class="ty05" v-if="endListOri.length > 10 && endList.length <= 10" @click="onClickListToggle('2','open')"/>
          <c-btnLine01 :btnText="''" :btn-show="true" class="ty06" v-if="endListOri.length > 10 && endList.length > 10" @click="onClickListToggle('2','close')"/>
        </div>
        <div class="box" v-if="completeList.length > 0">
          <div class="txt-date">{{t('message.complete')}}</div>
          <div class="list-inner">
            <div class="header-group">
              <div class="col">{{t('message.title')}}</div>
              <div class="col">{{t('message.stage')}}</div>
              <div class="col">{{t('message.progress')}}</div>
              <div class="col">{{t('message.period')}}</div>
            </div>
            <ul>
              <li
                v-for="(item, i) in completeList"
                :key="'todo'+i"
                :class="getClass(item)">
                <v-btn  @click="onClickItem(item)">
                  <span class="t1">{{ item.title }}</span>
                  <span class="t2">{{ item.type != 't'?item.periodSeq+t('message.sessionNumber'):'' }}</span>
                  <span class="t3">{{ getStatus(item) }}</span>
                  <span class="t4">{{ item.type != 't'?dayjs(item.startDate).format('YYYY-MM-DD')+'~'+dayjs(item.endDate).format('YYYY-MM-DD'):dayjs(item.goalDate).format('YYYY-MM-DD')}}</span>
                </v-btn>
              </li>
            </ul>
          </div>
        </div>
        <div class="btn-group">
          <c-btnLine01 :btnText="''" :btn-show="true" class="ty05" v-if="completeListOri.length > 10 && completeList.length <= 10" @click="onClickListToggle('3','open')"/>
          <c-btnLine01 :btnText="''" :btn-show="true" class="ty06" v-if="completeListOri.length > 10 && completeList.length > 10" @click="onClickListToggle('3','close')"/>
        </div>
      </div>
    </div>
  </div>
  <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
</template>

<script setup lang="ts">
import {ref, watch} from 'vue';
import CalendarService from "@/services/calendar.service";
import utils from "@/common/Utils";
import _ from 'lodash';
import {useCommonStore} from "@/store/common";
import {storeToRefs} from "pinia";
import dayjs from "dayjs";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)

//bind
const snackbar = ref(false)
const snackText = ref('')
const calenderModel = ref('weekly')
const bbsModel = ref(true)
const leadershipModel = ref(true)
const timelineModel = ref(true)
let allList = []
const todoList = ref([])
const todoListOri = ref([])
const endList = ref([])
const endListOri = ref([])
const completeList = ref([])
const completeListOri = ref([])

//ui
const CalenderItems = computed(() => [
  { title: t('message.weekly'), value: 'weekly' },
  { title: t('message.monthly'), value: 'monthly' }
])

//watch
watch(calenderModel, (newDate) => {
  utils.movePage('/safetyCalender2')
});

//hook
onMounted((): void => {
  CalendarService.getCalendarList({calendarType: 'w'}).then(
    (response) => {
      allList = []
      _.forEach(response.result.bbsList, (item,i)=> {
        allList.push({
          idx: item.idx,
          id: 'bbs' + i,
          startDate: toDate(item.startDate),
          endDate: toDate(item.endDate),
          classes: ["sort01"],
          title: item.monitoringTitle + '(' + item.periodSeq + ')',
          tooltip: item.monitoringTitle,
          type: 'b',
          dateStatus: item.dateStatus,
          answerCnt: item.answerCnt,
          periodCnt: item.periodCnt,
          status: item.status,
          periodSeq: item.periodSeq})
      })
      _.forEach(response.result.leadershipList, (item,i)=> {
        allList.push({
          idx: item.leadershipIdx,
          id: 'leadership' + i,
          startDate: toDate(item.startDate),
          endDate: toDate(item.endDate),
          classes: ["sort02"],
          title: item.leadershipTitle + '-' + (item.contentTitle??'') + '(' + item.periodSeq + ')',
          tooltip: item.leadershipTitle + '-' + (item.contentTitle??''),
          type: 'l',
          dateStatus: item.dateStatus,
          answerCnt: (item.freeboardAnswerCnt || 0) + (item.quizAnswerCnt || 0) +(item.monitoringAnswerCnt || 0),
          periodCnt: item.periodCnt,
          status: item.status,
          periodSeq: item.periodSeq})
      })
      _.forEach(response.result.timelineList, (item,i)=> {
        allList.push({
          idx: item.idx,
          id: 'timeline' + i,
          startDate: toDate(item.goalDate),
          formatDate: toDate(item.goalDate).toISOString().split('T')[0],
          classes: ["sort03"],
          title: item.action,
          tooltip: item.action,
          type: 't',
          dateStatus: item.dateStatus,
          answerCnt: 0, //timeline은 0
          periodCnt: 0, //timeline은 0
          status: item.status,
          situation: item.situation})
      })

      todoList.value = _.filter(allList, (item:any)=>{
        const todayStr = new Date().toISOString().slice(0, 10)
        const startDate = dayjs(item.startDate).format('YYYY-MM-DD')
        const endDate = dayjs(item.endDate).format('YYYY-MM-DD')
        return (item.dateStatus=='ready' || item.dateStatus=='warning')&&(item.answerCnt==0 && item.status!=4 && startDate <= todayStr && todayStr <= endDate)
      })
      todoListOri.value = todoList.value
      if(todoList.value.length > 10)
        todoList.value = _.take(todoList.value, 10)
      endList.value = _.filter(allList, item=>(item.dateStatus=='end')&&(item.answerCnt==0 && item.status!=4))
      endListOri.value = endList.value
      if(endList.value.length > 10)
        endList.value = _.take(endList.value, 10)
      completeList.value = _.filter(allList, item=>((item.answerCnt>=item.periodCnt && item.answerCnt > 0) || item.status==4))
      completeListOri.value = completeList.value
      if(completeList.value.length > 10)
        completeList.value = _.take(completeList.value, 10)
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
})

//function
const changeSwitch = ()=>{
  const selectedTypes = []
  let isBbs = bbsModel.value
  let isLeadership = leadershipModel.value
  let isTimeline = timelineModel.value
  let newList = []
  if(isBbs) selectedTypes.push('b')
  if(isTimeline) selectedTypes.push('t')
  if(isLeadership) selectedTypes.push('l')

  newList = _.filter(allList, item => selectedTypes.includes(item.type))

  todoList.value = _.filter(newList, (item:any)=>{
    const todayStr = new Date().toISOString().slice(0, 10)
    const startDate = dayjs(item.startDate).format('YYYY-MM-DD')
    const endDate = dayjs(item.endDate).format('YYYY-MM-DD')
    return (item.dateStatus=='ready' || item.dateStatus=='warning')&&(item.answerCnt==0 && item.status!=4 && startDate <= todayStr && todayStr <= endDate)
  })
  todoListOri.value = todoList.value
  if(todoList.value.length > 10)
    todoList.value = _.take(todoList.value, 10)
  endList.value = _.filter(newList, item=>(item.dateStatus=='end')&&(item.answerCnt==0 && item.status!=4))
  endListOri.value = endList.value
  if(endList.value.length > 10)
    endList.value = _.take(endList.value, 10)
  completeList.value = _.filter(newList, item=>((item.answerCnt>=item.periodCnt && item.answerCnt > 0) || item.status==4))
  completeListOri.value = completeList.value
  if(completeList.value.length > 10)
    completeList.value = _.take(completeList.value, 10)
}

/*
리스트 클래스(li에 기입):
sort01 안전관찰
sort02 안전리더십
sort03 시정조치
--
state01 진행전
state02 임박
state03 종료
state04 완료
*/
const getClass = (item:any):string=>{
  let returnClass = '';
  //타입체크
  if(item.type == 'b')
    returnClass += ' sort01'
  else if(item.type == 'l')
    returnClass += ' sort02'
  else if(item.type == 't')
    returnClass += ' sort03'
  //상태
  if(item.type == 't'){
    if(item.status == '4')
      returnClass += ' state04'
    else if(item.status != '4' && item.dateStatus == 'ready')
      returnClass += ' state01'
    else if(item.status != '4' && item.dateStatus == 'warning')
      returnClass += ' state02'
    else if(item.status != '4' && item.dateStatus == 'end')
      returnClass += ' state03'
  }
  else {
    if(item.answerCnt > 0)
      returnClass += ' state04'
    else if(item.answerCnt == 0 && item.dateStatus == 'ready')
      returnClass += ' state01'
    else if(item.answerCnt == 0 && item.dateStatus == 'warning')
      returnClass += ' state02'
    else if(item.answerCnt == 0 && item.dateStatus == 'end')
      returnClass += ' state03'
  }

  return returnClass
}

//상태문자
const getStatus = (item:any):string=>{
  let returnClass = '';
  //상태
  if(item.type == 't'){
    if(item.status == '4')
      returnClass += t('message.complete')
    else if(item.status == '3')
      returnClass += t('message.onHold')
    else if(item.status == '2')
      returnClass += t('message.inProgress')
    else if(item.status == '1')
      returnClass += t('message.ready')
  }
  else {
    if(item.answerCnt > 0)
      returnClass += t('message.complete')
    else if(item.answerCnt == 0 && item.dateStatus == 'ready')
      returnClass += t('message.statusPreparing')
    else if(item.answerCnt == 0 && item.dateStatus == 'warning')
      returnClass += t('message.statusUpcoming')
    else if(item.answerCnt == 0 && item.dateStatus == 'end')
      returnClass += t('message.statusExpired')
  }

  return returnClass
}

//아이템이동
const onClickItem = (item:any):void=>{
  if(item.type == 'b')
    utils.movePage('/monitoring/1/'+item.idx)
  else if(item.type == 't')
    utils.movePage('/myBoardDetail/'+item.idx)
  else if(item.type == 'l')
    utils.movePage('/safetyLeadershipRun/1/'+item.idx)
}

const toDate = (date:string): Date=>{
  const t = new Date(date)
  return new Date(t.getFullYear(), t.getMonth(), t.getDate())
}

const onClickListToggle = (listType, openType)=>{
  if(listType == '1') {
    if(openType == 'open')
      todoList.value = todoListOri.value
    else if(openType == 'close')
      todoList.value = _.take(todoListOri.value, 10);
  }
  else if(listType == '2') {
    if(openType == 'open')
      endList.value = endListOri.value
    else if(openType == 'close')
      endList.value = _.take(endListOri.value, 10);
  }
  else if(listType == '3') {
    if(openType == 'open')
      completeList.value = completeListOri.value
    else if(openType == 'close')
      completeList.value = _.take(completeListOri.value, 10);
  }
}
</script>


<style lang="scss">

</style>
